import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Benefits: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.10743 2.97917C3.7234 1.3632 6.29812 1.29033 8.00054 2.76057C9.70188 1.29033 12.2766 1.3632 13.8925 2.97917C15.5056 4.59224 15.5811 7.16067 14.119 8.86313L8.94281 14.0572C8.44574 14.5542 7.65394 14.5768 7.13014 14.1249L7.05721 14.0572L1.88095 8.86313C0.418865 7.16067 0.494358 4.59224 2.10743 2.97917ZM3.05024 3.92197C1.91214 5.06007 1.87962 6.88507 2.95269 8.06247L3.05024 8.1646L8.00001 13.1143L11.5351 9.57833L9.17848 7.2218L8.47141 7.92893C7.69034 8.70993 6.42401 8.70993 5.64296 7.92893C4.86192 7.14787 4.86192 5.88153 5.64296 5.10049L7.04374 3.69882C5.90196 2.78475 4.24718 2.82662 3.15241 3.82442L3.05024 3.92197ZM8.70708 5.80759C8.96741 5.54724 9.38954 5.54724 9.64988 5.80759L12.4779 8.63553L12.9497 8.1646C14.1213 6.99307 14.1213 5.09355 12.9497 3.92197C11.8116 2.78387 9.98661 2.75136 8.80928 3.82442L8.70708 3.92197L6.58577 6.04329C6.34402 6.28505 6.32675 6.66628 6.53397 6.92793L6.58577 6.98613C6.82754 7.22787 7.20874 7.24513 7.47041 7.03793L7.52861 6.98613L8.70708 5.80759Z"
        fill={color}
      />
    </svg>
  );
};

export default Benefits;
